import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep" data-id="element-93" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-94" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl uppercase tracking-wide text-gold" data-id="element-95" data-mp="3ghc2o28413o8">Bootcamp Ready™</h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-96" data-mp="32lrlpcbxyvjg">
          The 0-Decision Framework™ — because programming your classes
          shouldn&apos;t cost you every Sunday night.
        </p>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-1 text-[13px] text-white/70" data-id="element-97" data-mp="3ud7g3sjqpmk8">
          <a href="mailto:[SUPPORT_EMAIL]" className="inline-flex min-h-[44px] items-center px-1 hover:text-white hover:underline" data-id="element-98" data-mp="36d26u3xsnlq">[SUPPORT_EMAIL]</a>
          <a href="[INSTAGRAM_URL]" className="inline-flex min-h-[44px] items-center px-1 hover:text-white hover:underline" data-id="element-99" data-mp="3qcduj5trsjui">[@handle]</a>
          <a href="[SITE_URL]" className="inline-flex min-h-[44px] items-center px-1 hover:text-white hover:underline" data-id="element-100" data-mp="2a19vns22jyzx">[www.site.com]</a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-navy-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-101" data-mp="3l8qxg7f96pt1">
          Bootcamp Ready is a programming resource for fitness professionals. It
          does not replace a fitness certification, CPR/first-aid training,
          client health screening or medical advice. Coaches are responsible for
          adapting every session to their clients, space and local regulations.
          Results depend on the coach and the group; no specific outcome is
          guaranteed. © Bootcamp Ready™ 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}